import {initUserMemoryRepository} from './website-ui/repositories/user-memory-repository';

initUserMemoryRepository();
